module.exports = __webpack_public_path__ + "img/iba-scan-1.3d7e330b.png";